import { useQuery } from '@tanstack/react-query';
import { queryKey } from '../constant/queryKey';
import { affiliateService } from 'shared/src/api/affiliateService';
import { useGoodsSno } from '../hooks/useGoodsSno';

export const useAffiliateAiContentEligibility = ({
  enabled,
}: {
  enabled: boolean;
}) => {
  const goodsSno = useGoodsSno();

  return useQuery({
    queryKey: queryKey.affiliateAiContentEligibility(goodsSno),
    queryFn: () => affiliateService.getAffiliateAiContentEligibility(goodsSno),
    enabled,
  });
};
